export default "__VITE_ASSET__B0wbtHT5__"